<template>
  <div>
    <top/>
    <el-container>

      <el-container>
        <sider></sider>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import top from '../layouts/top.vue'
import sider from '../layouts/sidebar.vue'
export default{
  components:{
    top,
    sider
  }


}
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/views/home.vue